import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';

export const NomNomSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 684.68 660.52">
    <defs>
      <linearGradient
        id="New_Gradient_Swatch_1"
        x1="124.11"
        y1="141.8"
        x2="571.8"
        y2="141.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ed1c24" />
        <stop offset="1" stopColor="#f7941e" />
      </linearGradient>
      <linearGradient
        id="New_Gradient_Swatch_1-2"
        x1="240.66"
        y1="333.57"
        x2="572.06"
        y2="333.57"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-3"
        x1="124.29"
        y1="506.59"
        x2="572.53"
        y2="506.59"
        xlinkHref="#New_Gradient_Swatch_1"
      />
    </defs>
    <g id="Layer_50" data-name="Layer 50">
      <path
        d="M263.65,245.76a535.79,535.79,0,0,0,80.69,5.88c62.77,0,116.78-9.49,161.3-27,44.52-18.25,67.15-39.42,67.15-65V118.07c0-23.35-22.63-43.79-67.15-60.58C460.39,40.71,407.11,32,344.34,32c-62,0-116,8.76-161.31,25.54-29.17,11-48.75,23.6-58.92,37.53A220.55,220.55,0,0,1,263.65,245.76Z"
        style={{ fill: 'url(#New_Gradient_Swatch_1' }}
      />
      <path
        d="M506.37,396.16c44.52-20.44,66.42-44.52,66.42-74.45V246.53c-2.19-7.3-4.38-7.3-8,0-13.87,19.71-40.87,35.77-82.47,48.91-40.88,12.4-86.86,19-138,19A527.25,527.25,0,0,1,271,309.48a218.8,218.8,0,0,1-30.35,105,451.29,451.29,0,0,0,103.68,11.56C407.84,426.08,461.85,415.87,506.37,396.16Z"
        style={{ fill: 'url(#New_Gradient_Swatch_1-2' }}
      />
      <path
        d="M564,412.22c-13.87,22.62-41.6,40.87-80.28,56.93Q422.43,491,345.8,491q-77.73,0-138-21.89c-3.16-1.13-5.68-2.46-8.67-3.64a219.91,219.91,0,0,1-74.89,44.88c10.06,20.43,30.14,39.69,60.93,57.29q69,39.42,159.85,39.41c62,0,115.32-13.86,160.57-40.14,45.25-27,67.88-56.2,67.88-88.31v-65C573.52,404.19,569.87,403.46,564,412.22Z"
        style={{ fill: 'url(#New_Gradient_Swatch_1-3)' }}
      />
    </g>
  </svg>
);

const Svg403 = () => (
  <svg height="252" width="252" fill="currentColor">
    <image
      alignmentBaseline="middle"
      href="/static/img/nnd-403.png"
      height="252"
      width="252"
    />
  </svg>
);

const Svg404 = () => (
  <svg height="252" width="252" fill="currentColor">
    <image
      alignmentBaseline="middle"
      href="/static/img/nnd-404.png"
      height="252"
      width="252"
    />
  </svg>
);

const Svg502 = () => (
  <svg height="252" width="252" fill="currentColor">
    <image
      alignmentBaseline="middle"
      href="/static/img/nnd-502.png"
      height="252"
      width="252"
    />
  </svg>
);

export const Icon403 = (props) => <Icon component={Svg403} {...props} />;
export const Icon404 = (props) => <Icon component={Svg404} {...props} />;
export const Icon502 = (props) => <Icon component={Svg502} {...props} />;

export default (props) => <Icon component={NomNomSvg} {...props} />;
